// extracted by mini-css-extract-plugin
export default {"paymentSuccessfulContainer":"PaymentSuccessful_paymentSuccessfulContainer__iGH3L","message":"PaymentSuccessful_message__Sgtxr"};